import { useState, useEffect } from "react";
import { Route, Routes, Switch } from 'react-router-dom';
import JsonData from "./data/data.json";

import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Navigation } from "./components/navigation";
import { Footer } from "./components/footer";
import Footerdetail from "./components/Footerdetail";
import Home from "./Home";
import { PageNotFound } from "./components/pageNotFound";
import { Privacypolicy } from "./components/pages/privacypolicy";

import { ROService } from "./components/pages/ro";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});


const App = () => {

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <div className='social'>
        <div>
          <a className="whatsappscreen" href="https://api.whatsapp.com/send?phone=919912300212" target="_blank" rel="noreferrer">
            <i className="fa fa-whatsapp"></i>
          </a>
        </div>
        <div>
          <a className="phonescreen" href="tel:9912300212">
            <i className="fa fa-phone"></i>
          </a>
        </div>
      </div>
      <Navigation />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        
        

        {/*<Route path="/ac" element={<ACService />} /> 
        <Route path="/ro" element={<ROService />} />*/}
        
        
        
      </Routes>
      <Footerdetail data={landingPageData.Contact} />
      {/*
      <Footer data={landingPageData.Footer} /> */}
    </div>

  );
};


export default App;
